import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    padding: theme.spacing(8, 4),
  },
  icon: {
    margin: theme.spacing(4, 0),
    textAlign: 'center',
    '& > *': {
      width: '48px !important',
      height: '48px !important',
      opacity: '0.6',
    },
  },
  title: {
    margin: theme.spacing(4, 0),
    textAlign: 'center',
  },
  text: {
    margin: theme.spacing(4, 0),
    textAlign: 'center',
  },
}))
